export class DocumentosPessoaisDto{
   numeCartIdent: string;
   descOrgaoEmissaoRg: string;
   codgUfRG: string;
   dataExpedicaoRg: string;
   numeCnh: number;
   descCatgCnh: string;
   dataVencCnh: string;
   dataExpedCnh: string;
   ufCnh: string;
   dataPrimeiraCnh: string;
   numeTituloEleitor: number;
   codgUfTituloEleitor: string;
   numeZonaTitEleitor: number;
   numeSecaoTitEleitor: number;
   descOrgaoClasse: string;
   numeCartConsReg: string;
   dataEmisCartConsReg: string;
   codgUfCartConsReg: string;
   isAnexoRg: boolean;
   isAnexoCnh: boolean;
   isAnexoTituloEleitor: boolean;
}
